import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import pavingHeader from '../_content/IMG_3317.webp'
import pavingExample1 from '../_content/paving1.webp'
import pavingExample2 from '../_content/paving2.webp'
import pavingExample3 from '../_content/paving4.webp'
import pavingExample4 from '../_content/paving3.webp'
import pavingExample5 from '../_content/paving5.webp'
import pavingExample6 from '../_content/paving6.webp'
import pavingExample7 from '../_content/paving7.webp'
import pavingExample8 from '../_content/paving8.webp'
import pavingExample9 from '../_content/paving9.webp'
import pavingExample10 from '../_content/paving10.webp'
import pavingExample11 from '../_content/paving11.webp'
import pavingExample12 from '../_content/paving12.webp'
import pavingExample13 from '../_content/paving13.webp'
import pavingExample14 from '../_content/paving14.webp'
import pavingExample15 from '../_content/paving15.webp'
import pavingExample16 from '../_content/paving16.webp'
import pavingExample17 from '../_content/paving17.webp'
import pavingExample18 from '../_content/paving18.webp'
import pavingExample19 from '../_content/readgarden.webp'

const PavingServices = () => {
  return (
    <>
      <ServicesHeader background={pavingExample3} text="Paving Services" />

      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Transform your outdoor space with high-quality paving across Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Enhance your driveway, patio or pathways
            </Typography>

            <Typography className="section-subtext">
              We design and install durable paving that improves both appearance and functionality.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                { title: 'Expert Craftsmanship', text: 'Precision work using high-quality materials, installed with years of experience.' },
                { title: 'Custom Designs', text: 'Tailored solutions to suit your space and style.' },
                { title: 'Reliable Service', text: 'Professional, efficient and stress-free process, from consultation to installation.' },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[pavingExample19, pavingExample18, pavingExample9, pavingExample17, pavingExample15, pavingExample3,
          pavingExample16, pavingExample7, pavingExample5, pavingExample1, pavingExample13, pavingExample11,
          pavingExample10, pavingExample8, pavingExample12, pavingExample4, pavingExample14, pavingExample6,
          pavingHeader, pavingExample2 ].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia component="img" image={img} className="image-media" />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default PavingServices